import flatpickr from 'flatpickr';
import flatpickerConfig from '../../../../resources/assets/js/components/config.flatpickr';

function datetimePickerApplyMasks(){
    flatpickr('.datepicker', flatpickerConfig.datepicker);
    flatpickr('.datepicker-on-datatable', flatpickerConfig.datepickerdatatable);
    flatpickr('.datetimepicker', flatpickerConfig.datetimepicker);
    flatpickr('.daterangepicker', flatpickerConfig.daterangepicker);
    flatpickr('.timepicker', flatpickerConfig.timepicker);
}

datetimePickerApplyMasks();

// export for optional reuse
export { datetimePickerApplyMasks };